/**
* Toggle Featured Treatments JS
* -----------------------------------------------------------------------------
*
* All the JS for the Toggle Featured Treatments component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'toggle-featured-treatments',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      cardContentPositioning();
      $( window ).on( 'resize', function() {
        cardContentPositioning();
      } );
      function cardContentPositioning() {
        if ( window.innerWidth > 768 ) {
          $( '.toggle-featured-treatments__card-hover-area' ).each( function() {
            const hoverContent = $( this ).find( '.toggle-featured-treatments__card-hover-content' );
            const descriptionHeight = hoverContent.height();
            $( this ).css( 'transform', `translateY(${descriptionHeight}px)` );
          } );
        } else {
          $( '.toggle-featured-treatments__card-hover-area' ).each( function() {
            $( this ).css( 'transform', 'translateY(0)' );
          } );
        }
      }

      $( '.toggle-featured-treatments__category-button' ).on( 'click', function() {
        cardContentPositioning();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'toggle-featured-treatments', COMPONENT );
} )( app );
